import React from "react";
import { Tooltip } from "antd";
import { isString } from "lodash";
import ThumbsUpIcon from "../../../icons/thumbsUpIcon";
import ThumbsDownIcon from "../../../icons/thumbsDownIcon";
import useLocationHelpers from "../../../hooks/useLocationHelpers";
import { checkAccessPermission } from "../../../library/helpers";
import { AccessPermissionAction } from "../../../library/constants";

const AiFeedbackButtons = ({ feedback, messageFeedback, isFeedbackSent, onFeedback }) => {
  const { currentLocation } = useLocationHelpers();
  const settings = isString(currentLocation?.settings)
    ? JSON.parse(currentLocation?.settings)
    : currentLocation?.settings;
  const isEnabled = settings?.AUTO_RESPONSE_FEEDBACK;

  const canGiveAutoresponderFeedback = checkAccessPermission(
    AccessPermissionAction.AUTORESPONDER_FEEDBACK_SUBMIT
  );

  if (!isEnabled || !canGiveAutoresponderFeedback) return null;

  const feedbackValue = (messageFeedback || feedback || "").toUpperCase();
  return (
    <div className="flex justify-start w-[80%] lg:w-full">
      <Tooltip title="Good response">
        <span
          className="flex items-center justify-center w-8 h-8 transition-colors duration-200 border-0 cursor-pointer"
          onClick={() => onFeedback("good")}
        >
          <ThumbsUpIcon filled={feedbackValue === "GOOD"} />
        </span>
      </Tooltip>
      <Tooltip title="Poor response">
        <span
          className="flex items-center justify-center w-8 h-8 transition-colors duration-200 border-0 cursor-pointer"
          onClick={() => onFeedback("bad")}
        >
          <ThumbsDownIcon filled={feedbackValue === "BAD"} />
        </span>
      </Tooltip>
      {feedback !== null && isFeedbackSent && (
        <span className="text-[12px] font-[400] text-grey-500 mt-1">
          Thank you for the feedback! We&apos;re using this to improve Otto&apos;s future replies.
        </span>
      )}
    </div>
  );
};

export default AiFeedbackButtons;
